<script>
  export let type = "button";
  export let href = null;
  export let target = null;
  export let className = "";
  export let disabled = false;
  export let color = null;
</script>

<style lang="scss">
  @import "../style/theme-config.scss";

  button,
  a,
  .button {
    font: inherit;
    border: 1px solid $opeechee-blue;
    background: $opeechee-blue;
    padding: 0.5rem 1rem;
    color: white;
    border-radius: 5px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.26);
    cursor: pointer;
    text-decoration: none;
  }

  button,
  .button {
    display: inline-block;
    margin-bottom: 4px;
  }

  button:focus,
  .button:focus {
    outline: none;
  }

  button:hover,
  button.active,
  .button:hover,
  .button.active,
  a:hover,
  a:active {
    background: $color-highlight;
    border-color: $color-highlight;
    box-shadow: 1px 1px 8px rgba(77, 51, 51, 0.26);
  }

  button:disabled,
  button:disabled:hover,
  button:disabled:active,
  .button:disabled,
  .button:disabled:hover,
  .button:disabled:active {
    background: #ccc;
    border-color: #ccc;
    color: #959595;
    box-shadow: none;
    cursor: not-allowed;
  }

  .success {
    background: #01a129;
    border-color: #01a129;
  }

  .success:hover,
  .success:active {
    background: #1ac745;
    border-color: #1ac745;
  }

  .outline {
    background: transparent;
    color: $opeechee-blue;
    box-shadow: none;
  }

  .outline:hover,
  .outline:active {
    color: white;
    background: $opeechee-blue;
    border-color: $opeechee-blue;
    box-shadow: none;
  }

  .outline:disabled,
  .outline:disabled:hover,
  .outline:disabled:active {
    background: transparent;
    color: #ccc;
  }

  .outline.success {
    border-color: #01a129;
    color: #01a129;
  }

  .outline.success:hover,
  .outline.success:active {
    background: #c2ffd1;
  }

  .inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }
</style>

{#if href}
  <a {href} {target}>
    <slot />
  </a>
{:else if type === 'file'}
  <input
    class="inputfile {color}"
    type="file"
    name="file"
    id="file"
    on:change />
  <label class="button" for="file">
    <slot />
  </label>
{:else}
  <button class="{className} {color}" {type} {disabled} on:click>
    <slot />
  </button>
{/if}
